<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Tips')"
    width="400px"
    append-to-body
    :close-on-click-modal="false"
  >
    <div>
      <el-form label-position="left">
        <el-form-item label=" " label-width="80px">
          <el-form-item :label="$t('CargoMsg.Cargo_RecoverText')" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_RecoverRemark')">
          <el-input
            v-model="note"
            no="2"
            type="textarea"
            :rows="10"
            style="width: 285px;"
          />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button no="confirm" type="primary" @click="enterHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'CopyCancelCabinReservation',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    source: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      fullscreenLoading: false,
      listType: 0,
      fillType: 0,
      note: '',
      copyNum: 1
    }
  },
  computed: {},
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    enterHandler() {
      if (!this.note) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_RecoverRemark'))
        return
      }
      this.$emit('copy', { 'note': this.note })
      this.close()
    },
    close() {
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
